const Faq = () => {

    return (
        <div>
            <div className="section-content-container">
            <h1 className="titles">FAQ</h1>
            <p className="subtitle"> These are the most frequently asked questions:
            </p>
            <hr className="section-divider" />

            <p className='text-content'>
                <strong >How do I book a walk?</strong><br />
                On the home screen you will put your information including your email where you will
                receive a confirmation of your session.<br /><br />
                <strong>How much does the service cost?</strong><br />
                $20 for 30 minutes (Guaranteed route/milage as requested) <br /><br />
                <strong>How do I pay?</strong><br />
                You may pay with cash or Zelle (If needed it can be through other money transfer apps).<br /><br />
                <strong>How does a walking session look like?</strong><br />
                Each session is personalized to your dog's needs. You can choose the time and miles you would like for your dog to walk.<br /><br />
                <strong>What route will the dogwalker take?</strong><br />
                It will be your desired route. However, if you don't have any specific route, the dogwalker will create one that is fun and engaging for your dog to enjoy.<br /><br />
                <strong>How do I reschedule a walk session?</strong><br />
                You may reschedule 5 hours before your walking session and you may email us at: <a className="email-faq" href="mailto:info@alphadogwalks.com">info@alphadogwalks.com</a>
              
                
            </p>
        </div>
        </div>
        
    )


}

export default Faq;